import { inject, Injectable, signal } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of, tap } from 'rxjs';
import { ContestsResponse } from '../../how-do-i-win/interfaces/contests-response.interface';
import { ContestsDetailResponse } from '../../how-do-i-win/interfaces/contests-detail-response.interface';
import { GetCertificateResponse } from '../interfaces/get-certificate-response.interface';
import { CatContestsResponse } from '../interfaces/cat-contests-response.interface';

const API_URL = environment.apiUrl;

@Injectable({ providedIn: 'root' })
export class CatalogReferenceService {
  private _http = inject(HttpClient);

  private _catContestsCache = signal<CatContestsResponse[] | null>(null);
  private _contestsCache = new Map<string, ContestsResponse[]>();
  private _contestsDetailCache = new Map<string, ContestsDetailResponse[]>();

  getCatContests(): Observable<CatContestsResponse[]> {
    if (this._catContestsCache()) {
      return of(this._catContestsCache()!);
    }

    return this._http
      .get<CatContestsResponse[]>(`${API_URL}/GetCatContests`)
      .pipe(tap((catContests) => this._catContestsCache.set(catContests)));
  }

  getCertificates(): Observable<GetCertificateResponse[]> {
    return this._http.get<GetCertificateResponse[]>(
      `${API_URL}/GetCertificates`,
    );
  }

  getContests(catContestId: string): Observable<ContestsResponse[]> {
    if (this._contestsCache.get(catContestId)) {
      return of(this._contestsCache.get(catContestId)!);
    }

    const params = new HttpParams().set('catContestId', catContestId);

    return this._http
      .get<ContestsResponse[]>(`${API_URL}/GetContests`, {
        params,
      })
      .pipe(tap((contests) => this._contestsCache.set(catContestId, contests)));
  }

  getContestDetail(contestId: string): Observable<ContestsDetailResponse[]> {
    if (this._contestsDetailCache.get(contestId)) {
      return of(this._contestsDetailCache.get(contestId)!);
    }

    const params = new HttpParams().set('contestId', contestId);

    return this._http
      .get<ContestsDetailResponse[]>(`${API_URL}/GetContestDetail`, {
        params,
      })
      .pipe(
        tap((contestsDetail) =>
          this._contestsDetailCache.set(contestId, contestsDetail),
        ),
      );
  }
}
